module.exports = __webpack_public_path__ + "static/media/header-mobile.0fe35439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-mobile.png
// module id = 1368
// module chunks = 0